import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MenuItem, TextField } from '@material-ui/core';
import moment from 'moment';

import { Select } from '../../../components';
import FilterWrapper from '../filter-wrapper';
import parseDaytime from '../../../util/parse-daytime';

const defaultDayTime = { startTime: '05:00', endTime: '18:00' };

class DaytimeFilter extends Component {
  constructor(props) {
    super(props);

    const { startTime, endTime } = props.filterOptions;
    const selectedDaytime = startTime || endTime ? -2 : -1; // set to custom if times are loaded from the url

    this.state = {
      selectedDaytime,
    };
  }

  componentWillUnmount() {
    this.reset();
  }

  handleSetDaytime = (e) => {
    const { setFilterOption, daytimeOptions } = this.props;

    const daytimeIndex = e.target.value;

    if (daytimeIndex === -1) {
      // reset start and end-time
      setFilterOption({ key: 'startTime', value: null });
      setFilterOption({ key: 'endTime', value: null });
    } else if (daytimeIndex === -2) {
      setFilterOption({ key: 'startTime', value: parseDaytime(defaultDayTime.startTime, true) });
      setFilterOption({ key: 'endTime', value: parseDaytime(defaultDayTime.endTime, true) });
    } else if (daytimeIndex > -1) {
      const selectedDaytime = daytimeOptions[daytimeIndex];
      setFilterOption({ key: 'startTime', value: parseDaytime(selectedDaytime.startTime, true) });
      setFilterOption({ key: 'endTime', value: parseDaytime(selectedDaytime.endTime, true) });
    }

    this.setState({
      selectedDaytime: daytimeIndex,
    });
  }

  renderSelect = () => {
    const { daytimeOptions } = this.props;
    const { selectedDaytime } = this.state;

    // eslint-disable-next-line react/no-array-index-key
    const daytimeItems = daytimeOptions.map((d, i) => <MenuItem key={i} value={i}>{d.name}</MenuItem>);

    return (
      <Select
        placeholder="Lokal"
        value={selectedDaytime}
        onChange={this.handleSetDaytime}
      >
        <MenuItem key={-1} value={-1}>Keiner</MenuItem>
        {daytimeItems}
        <MenuItem key={-2} value={-2}>Benutzerdefiniert</MenuItem>
      </Select>

    );
  }

  handleChangeStartTime = (event) => {
    const { setFilterOption } = this.props;
    const time = event.target.value;

    setFilterOption({ key: 'startTime', value: parseDaytime(time, true) });
    this.setState({
      selectedDaytime: -2,
    });
  }

  handleChangeEndTime = (event) => {
    const { setFilterOption } = this.props;
    const time = event.target.value;

    setFilterOption({ key: 'endTime', value: parseDaytime(time, true) });
    this.setState({
      selectedDaytime: -2,
    });
  }

  reset = () => {
    const { setFilterOption } = this.props;

    setFilterOption({ key: 'startTime', value: null });
    setFilterOption({ key: 'endTime', value: null });
    this.setState({
      selectedDaytime: -1,
    });
  }

  timestampToString(time) {
    return moment.utc(Number.parseInt(time, 10)).format('HH:mm');
  }

  renderTextfields = () => {
    const { selectedDaytime } = this.state;
    const { filterOptions } = this.props;
    const { startTime, endTime } = filterOptions;

    if (selectedDaytime !== -2 && (!startTime || !endTime)) {
      return null;
    }

    return (
      <div>
        <TextField
          label="Von"
          type="time"
          InputLabelProps={{
            shrink: true,
          }}
          value={this.timestampToString(startTime)}
          onChange={this.handleChangeStartTime}
          required
        />
        <TextField
          label="Bis"
          type="time"
          InputLabelProps={{
            shrink: true,
          }}
          value={this.timestampToString(endTime)}
          onChange={this.handleChangeEndTime}
          required
        />
      </div>
    );
  }

  render() {
    const { isAdvancedFilter } = this.props;
    const { selectedDaytime } = this.state;

    return (
      <FilterWrapper
        title="Tageszeitfilter"
        isAdvancedFilter={isAdvancedFilter}
        resetFilter={this.reset}
        isResetDisabled={selectedDaytime === -1}
      >
        {this.renderSelect()}
        {this.renderTextfields()}
      </FilterWrapper>
    );
  }
}

DaytimeFilter.propTypes = {
  isAdvancedFilter: PropTypes.bool,
  filterOptions: PropTypes.object,
  daytimeOptions: PropTypes.array,
  setFilterOption: PropTypes.func,
};

DaytimeFilter.defaultProps = {
  isAdvancedFilter: false,
  filterOptions: null,
  daytimeOptions: [],
  setFilterOption: () => {},
};

export default DaytimeFilter;
